import {
  siteSessionAccessTokenKeyName,
  siteSessionIdTokenKeyName,
  siteSessionRefresh,
  siteSessionTokenKeyName,
} from "@/config/environment";
import { routes } from "@/config/routing/routes";
import { removeCookie } from "@/tools/cookies";

interface SignInRedirectPathOptions {
  hash?: string;
  pathname?: string;
  preserveReturnTo?: boolean;
  search?: string;
}

const authPaths = new Set([
  routes.signIn.absolute,
  routes.resetPassword.absolute,
  routes.sendResetPassword.absolute,
  routes.authCallback.absolute,
]);

export const clearAuthSession = () => {
  clearAuthCookies();

  if (typeof window !== "undefined") {
    const storage = window.localStorage;

    if (typeof storage?.clear === "function") {
      storage.clear();
    }
  }
};

export const clearAuthCookies = () => {
  removeCookie(siteSessionTokenKeyName);
  removeCookie(siteSessionRefresh);
  removeCookie(siteSessionIdTokenKeyName);
  removeCookie(siteSessionAccessTokenKeyName);
};

export const getSignInRedirectPath = ({
  hash = "",
  pathname = routes.signIn.absolute,
  preserveReturnTo = true,
  search = "",
}: SignInRedirectPathOptions = {}) => {
  if (!preserveReturnTo || authPaths.has(pathname)) {
    return routes.signIn.absolute;
  }

  const returnTo = `${pathname}${search}${hash}`;

  return `${routes.signIn.absolute}?returnTo=${encodeURIComponent(returnTo)}`;
};

export const redirectToSignIn = ({
  preserveReturnTo = true,
}: Pick<SignInRedirectPathOptions, "preserveReturnTo"> = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  const target = getSignInRedirectPath({
    hash: window.location.hash,
    pathname: window.location.pathname,
    preserveReturnTo,
    search: window.location.search,
  });
  const currentLocation = `${window.location.pathname}${window.location.search}`;

  if (currentLocation === target) {
    return;
  }

  window.location.replace(target);
};

export const resetSessionAndRedirectToSignIn = (
  options: Pick<SignInRedirectPathOptions, "preserveReturnTo"> = {},
) => {
  clearAuthSession();
  redirectToSignIn(options);
};
